/**
 * User role ID to name mapping
 * 
 * This file contains the mapping between Directus role UUIDs and their human-readable names.
 * Used across the application to translate role IDs to display names.
 */

export const ROLE_MAPPING = {
    '795c4d4b-4258-4f76-a116-70a03cb46d1a': 'Basic User',
    '86a762b0-b895-4690-a021-5bf77dc223d1': 'Administrator',
    'eb8cdb54-855f-4cfa-890f-4a8e77df93b3': 'Enterprise User',
    '471549aa-3ae5-45ec-a467-c5e664ca3233': 'Trial'
};

/**
 * Translates a role ID to a human-readable name
 * @param {string} roleId - The UUID role identifier from Directus
 * @returns {string} - The human-readable role name or the original ID if not found
 */
export const translateRole = (roleId) => {
    return ROLE_MAPPING[roleId] || roleId;
};

const rolesConfig = {
    ROLE_MAPPING,
    translateRole
};

export default rolesConfig; 